<script>
  import { createEventDispatcher } from "svelte";
  import { Icon, ArrowTopRightOnSquare, MagnifyingGlass } from "svelte-hero-icons";

  export let sidecars = [];
  export let selectedSidecars = [];
  export let showSidecarLink = false;

  const dispatch = createEventDispatcher();

  let searchQuery = "";

  $: filteredSidecars = searchQuery.trim()
    ? sidecars.filter((s) => {
        const label = s.pool ? `${s.serial_number} (${s.pool.name})` : s.serial_number;
        return label.toLowerCase().includes(searchQuery.toLowerCase());
      })
    : sidecars;

  function toggle(serialNumber) {
    const current = Array.isArray(selectedSidecars) ? selectedSidecars : [];
    const next = current.includes(serialNumber)
      ? current.filter((s) => s !== serialNumber)
      : [...current, serialNumber];
    selectedSidecars = next;
    dispatch("change", { selectedSidecars: next });
  }

  function reset() {
    selectedSidecars = [];
    dispatch("change", { selectedSidecars: [] });
  }
</script>

<div class="w-full text-xs border border-line-strong rounded px-2 py-1.5 bg-surface">
  <div class="flex justify-between items-center mb-1.5">
    <div class="font-medium text-content">Filter by Serial Numbers:</div>
    <button
      class="text-xs text-content-subtle hover:text-content-muted focus:outline-none transition-colors"
      on:click={reset}
    >
      Reset
    </button>
  </div>

  <div class="relative mb-1.5">
    <Icon
      src={MagnifyingGlass}
      class="absolute left-1.5 top-1/2 -translate-y-1/2 h-3 w-3 text-content-subtle pointer-events-none"
    />
    <input
      type="text"
      bind:value={searchQuery}
      placeholder="Search..."
      class="w-full pl-5 pr-2 py-0.5 text-xs border border-line-strong rounded bg-surface-sunken focus:outline-none focus:border-blue-300"
    />
  </div>

  <div class="overflow-y-auto max-h-[130px]">
    {#if filteredSidecars.length === 0}
      <div class="text-content-subtle py-1 px-1">No results</div>
    {:else}
      {#each filteredSidecars as sidecar (sidecar.serial_number)}
        <div
          class="flex items-center justify-between hover:bg-surface-hover rounded py-0.5 px-0.5 ml-1 group"
        >
          <label class="flex items-center space-x-2 cursor-pointer flex-1 min-w-0">
            <input
              type="checkbox"
              value={sidecar.serial_number}
              checked={Array.isArray(selectedSidecars) &&
                selectedSidecars.includes(sidecar.serial_number)}
              class="h-3 w-3 flex-shrink-0"
              on:change={() => toggle(sidecar.serial_number)}
            />
            <span class="truncate">
              {sidecar.pool
                ? `${sidecar.serial_number} (${sidecar.pool.name})`
                : sidecar.serial_number}
            </span>
          </label>
          {#if showSidecarLink}
            <a
              href="/admin/sidecars/{encodeURIComponent(sidecar.serial_number)}"
              target="_blank"
              rel="noopener noreferrer"
              class="ml-1 flex-shrink-0 text-gray-300 hover:text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity"
              title="Open sidecar page"
            >
              <Icon src={ArrowTopRightOnSquare} class="h-3 w-3" />
            </a>
          {/if}
        </div>
      {/each}
    {/if}
  </div>
</div>
